module.exports = __webpack_public_path__ + "media/site/images/case_studies/sensor_cloud/dashboard1@2x-8dd55bbad52e158d761b9a4b20b4102b.png";